import { useState } from "react";
import { resetBeachMatchStatus } from "../services/api";
import { getErrorAlertMessage } from "../utils/errors";

export function BeachMatchReset() {
  const [projectId, setProjectId] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: "success" | "error" | "info"; text: string } | null>(null);

  async function handleReset(e: React.FormEvent) {
    e.preventDefault();

    if (!projectId.trim()) {
      setMessage({ type: "error", text: "Please enter a Project ID (RR ID)" });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      const result = await resetBeachMatchStatus(projectId.trim());
      setMessage({
        type: "success",
        text: `✓ Beach match status cleared for ${result.project_id}. Previous status was: ${result.previous_status}`,
      });
      setProjectId(""); // Clear the input on success
    } catch (err) {
      const errorMsg = getErrorAlertMessage("reset beach match status", err);
      setMessage({ type: "error", text: errorMsg });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="panel">
      <h2>Reset Beach Match Status</h2>
      <p className="helper-text">
        Use this tool to manually clear stuck beach match statuses (PENDING, RUNNING, etc.) for a specific RR. This
        will delete the beach match record from the database, allowing you to trigger a fresh search.
      </p>

      <form onSubmit={handleReset} style={{ marginTop: "1.5rem" }}>
        <div className="form-grid">
          <label className="span-2">
            Project ID (RR ID)
            <input
              type="text"
              value={projectId}
              onChange={(e) => setProjectId(e.target.value)}
              placeholder="e.g., RR-2024-12345"
              disabled={loading}
              required
            />
          </label>
        </div>

        <div className="form-actions" style={{ marginTop: "1rem" }}>
          <button type="submit" className="primary" disabled={loading}>
            {loading ? "Resetting..." : "Reset Beach Match Status"}
          </button>
        </div>
      </form>

      {message && (
        <div
          className={`alert ${message.type === "success" ? "info" : "error"}`}
          style={{ marginTop: "1rem" }}
        >
          {message.text}
        </div>
      )}

      <div style={{ marginTop: "2rem", padding: "1rem", backgroundColor: "#f8fafc", borderRadius: "8px" }}>
        <h3 style={{ fontSize: "1rem", marginBottom: "0.5rem" }}>When to use this tool:</h3>
        <ul style={{ marginLeft: "1.5rem", lineHeight: "1.6" }}>
          <li>Beach match status shows PENDING or RUNNING for a long time without completing</li>
          <li>You need to re-run a beach match that had errors</li>
          <li>Testing beach matching functionality</li>
        </ul>
        <p style={{ marginTop: "0.75rem", fontSize: "0.9rem", color: "#64748b" }}>
          <strong>Note:</strong> This will permanently delete the beach match results for the specified RR. You can
          trigger a new search after resetting.
        </p>
      </div>
    </div>
  );
}
